import { Button, Grid, makeStyles, Typography, Container } from '@material-ui/core'
import { useSession } from 'components/session/session'
import CreateForm from 'components/task/renderTask/createForm'
import Router from 'next/router'
import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  card: {
    backgroundColor: 'var(--card-background)',
    color: 'var(--card-text) !important',
    '& .MuiStepLabel-label.MuiStepLabel-active': {
      color: 'var(--card-text) !important',
    },
    textAlign: 'center'
  },
  button: {
    backgroundColor: 'var(--button-color)',
    color: 'var(--button-text-color)',
    '&:hover': {
      backgroundColor: 'var(--button-color)',
    }
  },
  topSpacer: {
    height: '0px',
    [theme.breakpoints.up('md')]: {
      height: '50px',
    },
  },
}))

export default function HubCreator({ preview, passedComponents }) {
  const session = useSession()
  const classes = useStyles()
  const [components, setComponents] = useState(null)
  const [passedTask, setPassedTask] = useState(null)

  const { t, c } = Router.query

  const taskSession = {
    setTask: (val) => {
      setComponents(val)
    }
  }

  useEffect(() => {
    if (!session?.org?.data || !session?.user?.email) return
    const p = {}
    p.Components = [...(passedComponents || [])]
    if (!preview && session.org.data?.Entrypoint?.CustomizeComponents) p.Components = [...p.Components, ...(session.org.data?.Entrypoint?.Components ?? [])]
    setPassedTask(p)
  }, [session?.org?.data, session?.user?.email, preview, passedComponents])

  useEffect(() => {
    if (!passedTask) return
    if (passedTask.Components.length < 1) createHub()
  }, [passedTask])

  async function createHub() {
    console.log(JSON.stringify({ email: session.user.email, templateId: t, hubOwner: c, ...(components || []) }))
    const resp = (await fetch('/api/newhub', { method: 'POST', body: JSON.stringify({ email: session.user.email, templateId: t, hubOwner: c, ...(components || []) }) }))
    const url = await resp.text()
    console.log(url)
    if (resp.ok) Router.push('/onboarding/[clientid]?invite=true', url + '?invite=true')
    else window.location.replace(url)
  }

  if (!session?.org?.data || !passedTask) return <></>
  if (passedTask.Components.length < 1) return <></>
  return <Container><Grid container spacing={1} style={{ padding: '30px' }}>
    {!preview && <Grid item xs={12}><div className={classes.topSpacer}></div></Grid>}
    <Grid item xs={12}>
      <Typography variant='h3' style={{ textAlign: 'center' }}>Welcome to {session.org.data.Name}</Typography>
      <CreateForm selectedVersion={0} setSelectedVersion={() => { }} allowModify={true} preview={preview} passedTask={passedTask} taskSession={taskSession} />
      <Button varient='contained' className={classes.button} onClick={createHub}>Start</Button>
    </Grid>
  </Grid></Container>
}

HubCreator.propTypes = {
  preview: PropTypes.bool,
  passedComponents: PropTypes.object
}